import api from "../../../services/api";

const get = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/master/reason").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULT", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

const insert = ({ state }, type) => {
  return new Promise((resolve, reject) => {
    console.log(type)
    if (type == 0) {
      api.put("/master/reason/" + state.id, state.temp).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    } else {
      api.post("/master/reason", state.temp).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    }
  });
};

const remove = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.delete("/master/reason/" + state.id).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};

export default {
  get,
  insert,
  remove
};
